import type { PexVendorIconWeight } from './pex-icon-registry'

export const PEX_ICON_SIZES = {
  xs: 16,
  sm: 18,
  nav: 19,
  md: 20,
  lg: 24,
  xl: 32,
  '2xl': 48,
} as const

export type PexIconSize = keyof typeof PEX_ICON_SIZES
export type PexIconWeight = Extract<
  PexVendorIconWeight,
  'regular' | 'bold' | 'duotone' | 'fill'
>
export type PexIconTone =
  | 'default'
  | 'muted'
  | 'strong'
  | 'interactive'
  | 'navigation'
  | 'navigation-active'
  | 'signal'
  | 'success'
  | 'warning'
  | 'danger'
  | 'info'
  | 'on-emphasis'
  | 'topbar'
  | 'inherit'
